// Generated by Melange


function unresolved(command) {
  if (command.kind !== "prompt") {
    return false;
  }
  const match = command.state;
  switch (match) {
    case "accepted" :
    case "executing" :
    case "pending" :
    case "sent" :
      return true;
    default:
      return false;
  }
}

export {
  unresolved,
}
/* No side effect */
